// Note: move it inside the project if rapid-refresh becomes available offline
export const DEFAULT_RAPID_REFRESH_BACKGROUND_IMAGE =
  'https://media.edapp.com/image/upload/v1613096070/rapid-refresh/RR-default-background.png';

export const DEFAULT_RAPID_REFRESH_LOGO =
  'https://media.edapp.com/image/upload/v1613364455/rapid-refresh/RR-thumbnail.png';
